module.exports = __webpack_public_path__ + "img/katarina_events_9.df4d801f.jpg";